import request from "./request";

export async function getbanner() {
  return await request.get("/api/banner");
}

// export async function getGlobal() {
//   return await request.get("/api/setting");
// }

//博客相关
export async function getBlogsType() {
  return await request.get("/api/blogtype");
}

export async function getPageBlogs(page = 1, limit = 10, categoryid = -1) {
  return await request.get("/api/blog", {
    params: {
      page,
      limit,
      categoryid,
    },
  });
}

